module.exports = __webpack_public_path__ + "img/schedule.03ad91f6.png";